import { createFileRoute } from "@tanstack/react-router";
import AuthorArchive from "@/pages/AuthorArchive";
import { buildPageHead, breadcrumbSchema } from "@/lib/seo";
import {
  AUTHOR,
  AUTHOR_SLUG,
  authorPersonSchema,
  profilePageSchema,
} from "@/lib/authorEntity";

export const Route = createFileRoute("/authors/$slug")({
  head: ({ params }) => {
    const isAuthor = params.slug === AUTHOR_SLUG;
    const title = isAuthor
      ? "Marjohn Robillo, Revenue Operations Architect & AI Automation Expert"
      : "Author Not Found";
    const description = AUTHOR.description;
    return buildPageHead({
      title,
      description,
      path: `/authors/${params.slug}`,
      keywords:
        "Marjohn Robillo, revenue operations architect, GoHighLevel expert, HubSpot specialist, n8n workflow developer, Zapier automation, Make.com, Voice AI, Vapi, technical virtual assistant Philippines, CRM automation expert",
      ogType: "profile",
      schema: isAuthor
        ? [
            profilePageSchema(),
            authorPersonSchema(),
            breadcrumbSchema([
              { name: "Home", path: "/" },
              { name: "Authors", path: "/authors" },
              { name: AUTHOR.name, path: `/authors/${AUTHOR_SLUG}` },
            ]),
          ]
        : [],
      robots: isAuthor
        ? "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
        : "noindex, nofollow",
    });
  },
  component: AuthorArchive,
});
